function searchToggle(obj, evt){
    if ($(window).width() < 769){
        var container = $(obj).closest('.search-wrapper');
        if(!container.hasClass('active')){
            container.addClass('active');
            $('.games__menu__toggler').fadeOut();
            evt.preventDefault();
        }
        else if(container.hasClass('active') && $(obj).closest('.input-holder').length == 0){
            container.removeClass('active');
            $('.games__menu__toggler').fadeIn();
            // clear input
            container.find('.search-input').val('');
        }
    }
}

$(document).ready(function () {
    var nHelper = $(".helper"),
        nExpand = $("[data-expand]"),
        WIN = $(window),
        DOC = $(document),
        scrollTo = null,
        isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),
        isIOS = /(iPhone|iPod|iPad)/i.test(navigator.platform);
    var mainSlider = new Swiper ('[data-slider-main]', {
        loop: true,
        autoplay: {
            delay: 2000,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    });

    var winnersSlider = new Swiper ('[data-slider-winners]', {
        loop: true,
        autoplay: {
            delay: 1000,
        },
        slidesPerView: 1,
        spaceBetween: 10
    });


    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('.scroll-to-top').fadeIn();
        } else {
            $('.scroll-to-top').fadeOut();
        }
    });



    $('.scroll-to-top').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop : 0}, 800);
    });

    function checkMobile(element, wrapper, holder, type) {
        if (WIN.width() < 768){
            return type ? element.appendTo(wrapper) : element.prependTo(wrapper);
        } else {
            return type ? element.appendTo(holder) : element.prependTo(holder);
        }
    }

    function preventScroll() {
        $("body").bind('mousewheel DOMMouseScroll touchmove', function (event) {

            if (event.type == 'mousewheel') {
                scrollTo = (event.originalEvent.wheelDelta * -1);
            }

            else if (event.type == 'DOMMouseScroll') {
                scrollTo = 40 * event.originalEvent.detail;
            }

            if (scrollTo) {
                event.preventDefault();
                $(this).scrollTop(scrollTo + $(this).scrollTop());
            }

            return false;
        });
    }

    $('[data-expand]').click(function () {
        $('[data-games-group]').toggleClass('visible');
        $(this).toggleClass("opened");
    });

    $('[data-menumobile]').click(function () {
        $('[data-games-list]').fadeToggle(200);
        $(this).toggleClass("opened");
    });

    function moveDom(element) {
        $(element).responsiveDom({
            appendTo: element.replace("]", "-holder]"),
            mediaQuery: "(max-width: 640px)"
        });
    }
    moveDom("[data-widgets]");
    $('[data-modal]').magnificPopup({
        type: 'ajax',
        removalDelay: 300,
        mainClass: 'mfp-fade',
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
                $('[data-close]').click(function () {
                    $.magnificPopup.close();
                });
            }
        }
    });


    if (isMacLike) {
        $("html").addClass("apple");
    }
    if (isIOS) {
        $("html").addClass("ios");
    }
    var ua = window.navigator.userAgent;
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        $("html").addClass("edge");
    }
    if(ua.indexOf('Trident/7.0') + 1){
        $("html").addClass("ie");
    }

    if (/Android/i.test(navigator.userAgent)) {
        $("html").addClass("android");
    }
});